import Helper from './Helper';
import Hammer from '../lib/hammer';

class Gallery {
  constructor(config = {}) {
    const { galleryContainerSelector, gallerySplitClass } = config;

    this.getTranslatedLabels();
    this.galleryContainerSelector = galleryContainerSelector || '.ns-gallery';
    this.gallerySplitClass = gallerySplitClass || 'ns-gallery--split';
    this.galleryContainer = document.querySelectorAll(
      this.galleryContainerSelector
    );
    this.galleryContainerArray = Array.prototype.slice.call(
      this.galleryContainer
    );

    if (this.galleryContainer) {
      this.bindEvents();
    }
    this.showInProgress = false;
  }

  getTranslatedLabels(){
    if(document.documentElement.lang === 'fr-FR'){
      this.prevLabel = 'précédent';
      this.nextLabel = 'suivant';
    } else{
      this.prevLabel = 'Zurück';
      this.nextLabel = 'Vorwärts';
    }
  }

  checkForSplit(gallery, breakpoint) {
    if (Helper.hasClass(gallery, this.gallerySplitClass)) {
      gallery.setAttribute('data-splits', true);
    } else {
      gallery.setAttribute('data-splits', false);
    }
    let splits = gallery.getAttribute('data-splits');
    if (splits == 'false') {
      Helper.removeClass(gallery, this.gallerySplitClass);
    } else {
      if (breakpoint.matches) {
        Helper.addClass(gallery, this.gallerySplitClass);
      } else {
        Helper.removeClass(gallery, this.gallerySplitClass);
      }
    }
  }

  checkScreenSize(gallery, breakpoint, window) {

    if (Helper.hasClass(gallery, this.gallerySplitClass)) {
      gallery.setAttribute('data-splits', true);
    } else {
      gallery.setAttribute('data-splits', false);
    }
    let splits = gallery.getAttribute('data-splits');
    if (splits == 'false') {
      Helper.removeClass(gallery, this.gallerySplitClass);
    } else {
      if (breakpoint.matches) {
        Helper.addClass(gallery, this.gallerySplitClass);
      } else {
        Helper.removeClass(gallery, this.gallerySplitClass);
      }
    }

    window.addEventListener('resize', () => {
        if (splits == 'false') {
          Helper.removeClass(gallery, this.gallerySplitClass);
        } else {
          if (breakpoint.matches) {
            // console.log('addclass now');
            Helper.addClass(gallery, this.gallerySplitClass);
          } else {
            // console.log('removeclass now');
            Helper.removeClass(gallery, this.gallerySplitClass);
          }
        }
    });
  }

  bindEvents() {
    Helper.loadImagesInContainer(this.galleryContainerSelector);
    this.galleryContainerArray.forEach(gallery => {
      this.checkScreenSize(
        gallery,
        window.matchMedia('(min-width: 992px)'),
        window
      );
      this.buildGallery(gallery);
      const g = new Hammer(gallery);
      g.on('swipeleft', e => {
        if (this.showInProgress == false) {
          this.showInProgress = true;
          this.showNextSlide(gallery, () => {
            this.showInProgress = false;
          });
        } else {
          // console.log('currently busy');
        }
      });
      g.on('swiperight', e => {
        if (this.showInProgress == false) {
          this.showInProgress = true;
          this.showPrevSlide(gallery, () => {
            this.showInProgress = false;
          });
        } else {
          // console.log('currently busy');
        }
      });

      setTimeout(function(){
        const imgHeight = gallery.querySelector('.ns-img__img.loaded').offsetHeight;
        gallery.querySelector('.ns-gallery__counter').style.top = imgHeight+20+'px';
        gallery.style.paddingBottom = gallery.querySelector('.ns-gallery__counter').offsetHeight+20+'px';
        console.log(gallery.querySelector('.ns-img__img.loaded'));
        console.log(imgHeight);
      }, 500);

    });
  }

  buildNavigator(gallery) {
    const navigator = document.createElement('div');
    const prevButton = document.createElement('div');
    const nextButton = document.createElement('div');
    const counter = document.createElement('div');
    const current = document.createElement('span');
    const total = document.createElement('span');
    Helper.addClass(navigator, 'ns-gallery__navigator');
    Helper.addClass(prevButton, 'ns-gallery__prev');
    Helper.addClass(prevButton, 'ns-gallery__arrow');
    Helper.addClass(nextButton, 'ns-gallery__next');
    Helper.addClass(nextButton, 'ns-gallery__arrow');
    Helper.addClass(counter, 'ns-gallery__counter');
    Helper.addClass(current, 'ns-gallery__current-slide');
    Helper.addClass(total, 'ns-gallery__total-slides');


    if( Helper.hasClass(gallery, this.gallerySplitClass)){
      prevButton.innerHTML = `<span class="prevlabel">`+this.prevLabel+`</span>`;
      nextButton.innerHTML = `<span class="nextlabel">`+this.nextLabel+`</span>`;
    } else{
      prevButton.innerHTML = `<svg id="arrow" class="icon-arrow" width="28px" height="24px" viewBox="0 0 28 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <g transform="translate(-954.000000, -3887.000000)" stroke="currentColor" stroke-width="3">
              <g transform="translate(968.000000, 3899.000000) rotate(-90.000000) translate(-968.000000, -3899.000000) translate(958.000000, 3887.000000)">
                  <path d="M10,4.54747351e-13 L10,22"></path>
                  <polyline points="0 14 10 24 20 14"></polyline>
              </g>
          </g>
      </g>
    </svg>
    <span class="sr">prev</span>`;
      nextButton.innerHTML = `<svg id="arrow" class="icon-arrow" width="28px" height="24px" viewBox="0 0 28 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <g transform="translate(-954.000000, -3887.000000)" stroke="currentColor" stroke-width="3">
              <g transform="translate(968.000000, 3899.000000) rotate(-90.000000) translate(-968.000000, -3899.000000) translate(958.000000, 3887.000000)">
                  <path d="M10,4.54747351e-13 L10,22"></path>
                  <polyline points="0 14 10 24 20 14"></polyline>
              </g>
          </g>
      </g>
    </svg>
    <span class="sr">next</span>`;
    }

    counter.appendChild(current);
    counter.innerHTML += '<span class="ns-gallery__slash">/</span>';
    counter.appendChild(total);
    navigator.appendChild(prevButton);
    navigator.appendChild(counter);
    navigator.appendChild(nextButton);

    gallery.appendChild(navigator);
    prevButton.addEventListener('click', e => {
      if (this.showInProgress == false) {
        this.showInProgress = true;
        this.showPrevSlide(gallery, () => {
          this.showInProgress = false;
        });
      } else {
        // console.log('currently busy');
      }
    });

    nextButton.addEventListener('click', e => {
      if (this.showInProgress == false) {
        this.showInProgress = true;
        this.showNextSlide(gallery, () => {
          this.showInProgress = false;
        });
      } else {
        // console.log('currently busy');
      }
    });

  }

  buildGallery(gallery) {
    const numberOfSlides = gallery.childElementCount;
    const isNumber = Helper.hasClass(gallery, this.gallerySplitClass);
    const content = gallery.innerHTML;
    const innerWrap = document.createElement('div');
    Helper.addClass(innerWrap, 'ns-gallery__inner-wrap');
    const innerWrapper = document.createElement('div');
    Helper.addClass(innerWrapper, 'ns-gallery__inner');
    innerWrapper.innerHTML = content;
    innerWrap.appendChild(innerWrapper);
    if (isNumber) {
      innerWrapper.style.width = `${(numberOfSlides / 2) * 100}%`;
    } else {
      innerWrapper.style.width = `${numberOfSlides * 100}%`;
    }
    gallery.innerHTML = '';
    gallery.appendChild(innerWrap);

    this.buildNavigator(gallery);

    if (isNumber) {
      this.makeSlideActive(
        gallery,
        numberOfSlides,
        isNumber,
        [0, 1],
        gallery.querySelector('.ns-gallery__current-slide'),
        gallery.querySelector('.ns-gallery__total-slides')
      );
    } else {
      this.makeSlideActive(
        gallery,
        numberOfSlides,
        isNumber,
        [0],
        gallery.querySelector('.ns-gallery__current-slide'),
        gallery.querySelector('.ns-gallery__total-slides')
      );
    }
  }

  makeSlideActive(
    gallery,
    numberOfSlides,
    isNumber,
    indexArray,
    currentEl,
    totalEl
  ) {
    const items = gallery.querySelectorAll('figure');
    const itemsArray = Array.prototype.slice.call(items);
    const innerWrapper = gallery.querySelector('.ns-gallery__inner');
    let translatePerItem = 100 / numberOfSlides;
    // if (isNumber) {
    //   translatePerItem = 100 / numberOfSlides / 2;
    // }

    const currentlyActiveIndexes = [];

    itemsArray.forEach((item, index) => {
      const itemIndex = itemsArray.indexOf(item);
      if (indexArray.includes(itemIndex)) {
        Helper.addClass(item, 'active');
        currentlyActiveIndexes.push(index);

        if (isNumber) {
          if (currentlyActiveIndexes.length == 2) {
            innerWrapper.style.transform = `translateX(-${translatePerItem *
              (index - 1)}%)`;
          }
        } else {
          innerWrapper.style.transform = `translateX(-${translatePerItem *
            index}%)`;
        }
      } else {
        Helper.removeClass(item, 'active');
      }
    });
    gallery.setAttribute('data-active-slides', indexArray);
    gallery.setAttribute('data-number-of-slides', numberOfSlides);

    if (isNumber) {
      currentEl.innerHTML = indexArray[0] / 2 + 1;
      totalEl.innerHTML = numberOfSlides / 2;
    } else {
      currentEl.innerHTML = indexArray[0] + 1;
      totalEl.innerHTML = numberOfSlides;
    }
  }

  getIndexArray(gallery) {
    const string = gallery.getAttribute('data-active-slides');
    return string.split(',').map(Number);
  }

  showNextSlide(gallery, callback) {
    const numberOfSlides = gallery.getAttribute('data-number-of-slides');
    const isNumber = Helper.hasClass(gallery, this.gallerySplitClass);
    const indexArray = this.getIndexArray(gallery);
    const nextIndexArray = [];
    let numBefore = 0;
    indexArray.forEach((indexItem, i) => {
      if (i == 0) {
        if (isNumber) {
          if (indexItem >= numberOfSlides - 2) {
            numBefore = 0;
          } else {
            numBefore = indexItem + 2;
          }
        } else {
          if (indexItem >= numberOfSlides - 1) {
            numBefore = 0;
          } else {
            numBefore = indexItem + 1;
          }
        }
        nextIndexArray.push(numBefore);
      } else {
        nextIndexArray.push(numBefore + 1);
      }
    });

    this.makeSlideActive(
      gallery,
      numberOfSlides,
      isNumber,
      nextIndexArray,
      gallery.querySelector('.ns-gallery__current-slide'),
      gallery.querySelector('.ns-gallery__total-slides')
    );
    callback();
  }

  showPrevSlide(gallery, callback) {
    const numberOfSlides = gallery.getAttribute('data-number-of-slides');
    const isNumber = Helper.hasClass(gallery, this.gallerySplitClass);
    const indexArray = this.getIndexArray(gallery);
    const nextIndexArray = [];
    let numBefore = 0;
    indexArray.forEach((indexItem, i) => {
      if (i == 0) {
        if (indexItem == 0) {
          if (isNumber) {
            numBefore = numberOfSlides - 2;
          } else {
            numBefore = numberOfSlides - 1;
          }
        } else {
          if (isNumber) {
            numBefore = indexItem - 2;
          } else {
            numBefore = indexItem - 1;
          }
        }
        nextIndexArray.push(numBefore);
      } else {
        nextIndexArray.push(numBefore + 1);
      }
    });

    this.makeSlideActive(
      gallery,
      numberOfSlides,
      isNumber,
      nextIndexArray,
      gallery.querySelector('.ns-gallery__current-slide'),
      gallery.querySelector('.ns-gallery__total-slides')
    );
    callback();
  }
}
export default Gallery;
